// FS管理相关
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 获取银行开户行选项列表
export const getBankNameOptions = (params) => {
  return get(`${baseApi}/refundManage/bankList`, params);
}

// 获取用户信息
export const getUserInfo = (params) => {
  if (params.type === 'offline'){    
    return post(`${baseApi}/offlineRefund/queryUserInfo`, params);
  }
  return post(`${baseApi}/refundManage/refundPolicy`, params);
}
// 完善用户信息
export const saveUserInfo = (params) => {
  if (params.type === 'offline'){    
    return post(`${baseApi}/offlineRefund/submitUserInfo`, params);
  }
  return post(`${baseApi}/refundManage/submitUserInfo`, params);
}

// 线下退费-飞书审批确认
export const submitFeishuApproval = (params) => {
  return post(`${baseApi}/offlineRefund/submitFeishuApproval`, params);
}

// 上传申请书
export const contractUpload = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });
  const commonParams = {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  };
  if (params.type === 'offline'){
    return post(`${baseApi}/offlineRefund/uploadImage`, data, commonParams);
  }
  return post(`${baseApi}/refundManage/uploadImage`, data, commonParams);
}
